export default __webpack_public_path__ + "./images/ye.341375d7.png";